export const FARTHER_FROM_BROOKLYN = 'Farther From Brooklyn';
export const FARTHEST_FROM_BROOKLYN = 'Farthest from Brooklyn';
export const BROOKLYN = 'Brooklyn';



// WEBPACK FOOTER //
// ./src/constants/LocationGroups.js